import { useState, useEffect } from 'react';

// Define a interface para o objeto de tamanho da janela
interface Size {
    width: number | undefined;
    height: number | undefined;
}

export function useWindowSize(): Size {
    // Inicializa o estado com as dimensões da janela (ou undefined no lado do servidor)
    const [windowSize, setWindowSize] = useState<Size>({
        width: typeof window !== 'undefined' ? window.innerWidth : undefined,
        height: typeof window !== 'undefined' ? window.innerHeight : undefined,
    });

    useEffect(() => {
        // Manipulador para atualizar o estado com as novas dimensões
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }

        // Adiciona um listener para o evento de 'resize'
        window.addEventListener('resize', handleResize);

        // Chama o handler uma vez para definir o tamanho inicial
        handleResize();

        // Remove o listener quando o componente é desmontado
        return () => window.removeEventListener('resize', handleResize);
    }, []); // O array de dependências vazio garante que o efeito rode apenas uma vez na montagem

    return windowSize;
}